import { useState, useEffect } from "react";
import { History, TrendingUp, TrendingDown, ChevronDown, ChevronUp } from "lucide-react";
import { topPicksAPI } from "../services/api";

export default function Top5History({ onAnalyze }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    topPicksAPI.getHistory(14).then(data => {
      setHistory(data.history || []);
      setLoading(false);
    });
  }, []);

  if (loading) return (
    <div className="glass-card rounded-xl p-3" data-testid="top5-history">
      <div className="flex items-center gap-1.5 mb-2">
        <History className="w-3.5 h-3.5 text-cyan-400" />
        <span className="text-xs font-bold">Historique Top 5</span>
      </div>
      <div className="text-[10px] text-slate-500 text-center py-4">Chargement...</div>
    </div>
  );

  if (history.length === 0) return (
    <div className="glass-card rounded-xl p-3" data-testid="top5-history">
      <div className="flex items-center gap-1.5 mb-2">
        <History className="w-3.5 h-3.5 text-cyan-400" />
        <span className="text-xs font-bold">Historique Top 5</span>
      </div>
      <div className="text-[10px] text-slate-500 text-center py-4">Pas encore d'historique</div>
    </div>
  );

  const displayHistory = expanded ? history : history.slice(0, 3);

  return (
    <div className="glass-card rounded-xl p-3" data-testid="top5-history">
      <div className="flex items-center gap-1.5 mb-2">
        <History className="w-3.5 h-3.5 text-cyan-400" />
        <span className="text-xs font-bold">Historique Top 5</span>
        <span className="text-[9px] text-slate-500 ml-auto">{history.length}j</span>
      </div>

      <div className="space-y-1.5">
        {displayHistory.map((entry) => (
          <div key={entry.date} className="px-1.5 py-1 rounded bg-slate-800/20">
            <div className="text-[9px] font-bold text-cyan-400 mb-0.5">
              {new Date(entry.date).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" })}
            </div>
            {entry.daily?.length > 0 && (
              <div className="mb-0.5">
                <span className="text-[7px] text-slate-500 uppercase font-bold">Global </span>
                <span className="text-[8px] text-slate-400">
                  {entry.daily.map((p, i) => (
                    <span key={p.ticker} className="inline-flex items-center mr-1">
                      <span className="text-[7px] text-slate-500">{i + 1}.</span>
                      <span className="font-mono cursor-pointer text-cyan-400/80 hover:text-cyan-300 hover:underline transition-colors"
                        onClick={(e) => { e.stopPropagation(); onAnalyze?.(p.ticker); }}>
                        {p.ticker}
                      </span>
                      {p.perf_pct !== undefined && (
                        <span className={`ml-0.5 font-bold ${p.perf_pct >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                          {p.perf_pct >= 0 ? "+" : ""}{p.perf_pct}%
                        </span>
                      )}
                    </span>
                  ))}
                </span>
              </div>
            )}
            {entry.algo?.length > 0 && (
              <div>
                <span className="text-[7px] text-slate-500 uppercase font-bold">Algo </span>
                <span className="text-[8px] text-slate-400">
                  {entry.algo.map((p, i) => (
                    <span key={p.ticker} className="inline-flex items-center mr-1">
                      <span className="text-[7px] text-slate-500">{i + 1}.</span>
                      <span className="font-mono cursor-pointer text-cyan-400/80 hover:text-cyan-300 hover:underline transition-colors"
                        onClick={(e) => { e.stopPropagation(); onAnalyze?.(p.ticker); }}>
                        {p.ticker}
                      </span>
                      <span className="text-[7px] text-amber-400 ml-0.5">{p.composite}</span>
                      {p.perf_pct !== undefined && (
                        <span className={`ml-0.5 font-bold ${p.perf_pct >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                          {p.perf_pct >= 0 ? "+" : ""}{p.perf_pct}%
                        </span>
                      )}
                    </span>
                  ))}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>

      {history.length > 3 && (
        <button onClick={() => setExpanded(!expanded)}
          className="mt-1.5 w-full flex items-center justify-center gap-0.5 text-[9px] text-cyan-400 hover:text-cyan-300 transition-colors"
          data-testid="toggle-history">
          {expanded ? <ChevronUp className="w-2.5 h-2.5" /> : <ChevronDown className="w-2.5 h-2.5" />}
          {expanded ? "Moins" : `Tout (${history.length}j)`}
        </button>
      )}
    </div>
  );
}
